<template>
  <Dialog :open="open" @close="handleCancel">
    <template v-slot:title>
      <FlexRow justify="center">
        <Label text="見送りメッセージを送りますか？" size="h5" bold />
      </FlexRow>
    </template>
    <TextArea :rows="10" v-model="text" />
    <template v-slot:actions>
      <FlexRow justify="center" full-width>
        <Button outlined @click="handlePost">送信して見送りにする</Button>
        <Button outlined @click="handleClose">送信せずに見送りにする</Button>
        <Button outlined @click="handleCancel">キャンセル</Button>
      </FlexRow>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "../atoms/Dialog";
import Label from "../atoms/Label";
import FlexRow from "../atoms/FlexRow";
import TextArea from "../atoms/TextArea";
import Button from "../atoms/Button";
import ApiMixin from "../../ApiMixin";
export default {
  name: "FarewellMessageDialog",
  components: {Button, TextArea, FlexRow, Label, Dialog},
  mixins: [ApiMixin],
  props: {
    open: {
      type: Boolean
    },
    userName: {
      type: String,
    },
    companyName: {
      type: String,
    },
    messageId: {
      type: String,
    }
  },
  data() {
    return {
      text: ''
    }
  },
  computed: {
    defaultText() {
      return `${this.userName}様

お世話になっております。${this.companyName}採用担当です。

この度はお忙しい中、弊社の求人にご応募頂き誠にありがとうございました。
社内で慎重に検討させて頂いた結果、誠に残念ながら今回は採用を見送らせて頂くことになりました。

ご興味を持って頂いたにもかかわらず申し訳ございませんが、ご了承頂きますようお願い申し上げます。

末筆になりますが、貴殿の今後益々のご活躍をお祈り申し上げます。`
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    },
    handleClose() {
      this.$emit('close')
    },
    async handlePost() {
      await this.postClientUtterance(this.messageId, this.text, null)
      this.$emit('close', this.text)
    },
  },
  watch: {
    userName: {
      handler: function() {
        this.text = this.defaultText
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>